import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useEffect, useState } from 'react';
import { AppMainViewContext } from '../../ContextProviders/AppContextProvider';
import { ConsumerDao } from '../../data/ConsumerDAO';
import { ObjectViewType } from '../../types/AppTypes';
import { getViewDefintionFromObject } from '../factories/AttributeDefinitions';
import { ListerlizerAdapter } from '../factories/Listerlizer/legacy/ListerlizerAdapter';
const debug = process.env.REACT_APP_DEBUG && false;
export default function IndirectlyRelatedItemTab(props) {
    const { tabValue, resolvedContextObject, branchingQueryDefinition, targetObjectTypeId, viewDefinition: viewDefinitionIn } = props;
    debug && console.log(`IndirectlyRelatedItemTab for ${resolvedContextObject.name} to ${targetObjectTypeId}`);
    const [{ applicationData, UserFunctions }] = useContext(AppMainViewContext);
    const [hasRunQuery, setHasRunQuery] = useState(false);
    useEffect(() => {
        setHasRunQuery(false);
    }, [resolvedContextObject.sk, targetObjectTypeId]);
    const viewDefinition = viewDefinitionIn ?? getViewDefintionFromObject({ type: targetObjectTypeId });
    const query = async () => {
        let res = [];
        const applicationDataRes = applicationData?.applyBranchingQuery([resolvedContextObject], branchingQueryDefinition);
        const targetObjectsFromAppData = applicationDataRes?.getNodesOfType(targetObjectTypeId) ?? [];
        if (targetObjectsFromAppData.length > 0) {
            res = targetObjectsFromAppData;
        }
        else if (!hasRunQuery) {
            setHasRunQuery(true);
            const datastoreRes = await ConsumerDao.getGraphQueryRequestV2({ query: branchingQueryDefinition, contextObjects: [resolvedContextObject] });
            if (datastoreRes.err) {
                console.error(datastoreRes.err);
            }
            if (datastoreRes.data) {
                const datastoreNodeEdgeMapper = datastoreRes.data;
                UserFunctions.addObjectsToState(datastoreNodeEdgeMapper.getContainedNodesAndEdges());
            }
        }
        return res;
    };
    const columnVisibilityReferences = {
        dataTableReference: 'IndirectlyRelatedItemTab',
        objectTypeId: targetObjectTypeId,
        viewType: ObjectViewType.List,
    };
    return (_jsx(ListerlizerAdapter, { query,
        columnVisibilityReferences,
        viewDefinition,
        initialSort: [{ field: 'name', sort: 'asc' }] }));
}
